const webauthnRefusalKey = (answer) => {
  if (answer.kindNotAllowed) return (answer.cloud) ? 'secondFactorCloudPasskeyRefused' : 'secondFactorLocalKeyRefused';
  if (answer.tooMany) return 'secondFactorKeyTooMany';
  if (answer.methodNotAllowed) return 'secondFactorMethodNotAllowed';
  if (answer.badCode) return 'secondFactorLabelRefused';

  return 'secondFactorKeyRefused';
};

export default webauthnRefusalKey;
